import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import {
  ROOT,
  TRADITIONAL_RAFFLE_LIST,
  INSTANT_WIN_LIST,
  LUCKY_DRAW_DETAIL,
  LUCKY_DRAW_CREATE,
  LD_LIVE_DRAW,
  INSTANT_WIN_CREATE,
  LUCKY_DRAW_PARTICIPANTS,
  INSTANT_WIN_DETAIL,
  VIEW_TRADITIONAL_RAFFLE_WINNERS,
  VIEW_INSTANT_WIN_WINNERS,
  VIEW_TRADITIONAL_RAFFLE_CLAIM_LIST,
  VIEW_INSTANT_WIN_CLAIM_LIST,
} from "./config/lucky-draw-v2.route";
import { MainPage, LuckyDrawDetailPage, LuckyDrawParticipants } from "./pages";
import LuckyDrawCreatePage from "./pages/lucky-draw-create";
import ViewTranditionalRaffleWinnerPage from "./pages/viewTranditionalRaffleWinnerPage";
import ViewInstantWinWinnerPage from "./pages/viewInstantWinWinnerPage";

export default function LuckyDrawModule() {
  return (
    <Switch>
      <Route exact path={ROOT} render={() => <Redirect to={TRADITIONAL_RAFFLE_LIST} />} />
      <Route exact path={TRADITIONAL_RAFFLE_LIST} render={(props) => <MainPage {...props} defaultTab={0} />} />
      <Route exact path={INSTANT_WIN_LIST} render={(props) => <MainPage {...props} defaultTab={1} />} />
      <Route
        exact
        path={LUCKY_DRAW_CREATE}
        render={(props) => <LuckyDrawCreatePage {...props} type={1} />}
      />
      <Route
        exact
        path={INSTANT_WIN_CREATE}
        render={(props) => <LuckyDrawCreatePage {...props} type={2} />}
      />
      <Route exact path={LUCKY_DRAW_DETAIL} component={LuckyDrawDetailPage} />
      <Route exact path={LUCKY_DRAW_PARTICIPANTS} component={LuckyDrawParticipants} />
      <Route exact path={INSTANT_WIN_DETAIL} component={LuckyDrawDetailPage} />
      <Route exact path={VIEW_TRADITIONAL_RAFFLE_WINNERS} component={ViewTranditionalRaffleWinnerPage} />
      <Route exact path={VIEW_INSTANT_WIN_WINNERS} component={ViewInstantWinWinnerPage} />
      <Route exact path={VIEW_TRADITIONAL_RAFFLE_CLAIM_LIST} render={(props) => <ViewTranditionalRaffleWinnerPage {...props} isClaimListView={true} />} />
      <Route exact path={VIEW_INSTANT_WIN_CLAIM_LIST} render={(props) => <ViewInstantWinWinnerPage {...props} isClaimListView={true} />} />
      <Route path="*">
        <Redirect to="/admin/invalid" />
      </Route>
    </Switch>
  );
}

export { ROOT, LD_LIVE_DRAW };
